import { render, staticRenderFns } from "./EditBlacklist.vue?vue&type=template&id=9fbd9254&"
import script from "./EditBlacklist.vue?vue&type=script&lang=ts&"
export * from "./EditBlacklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports